var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQuotationMarks(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 392.24 273.03",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#102b4e;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "QuotationMarks") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M212.21,226.8c0,41,27.83,109.22,88.13,109.22,32.46,0,51-22.75,51-54.61,0-25-25.51-43.23-32.47-47.78-18.55-18.2-25.51-29.58-25.51-54.6,0-45.52,62.6-81.92,90.44-88.75,9.27-2.27,13.91-5.68,11.6-18.19-1.17-6.83-5.81-9.11-13.93-9.11-23.18,0-169.28,41-169.28,163.82m-208.45,0c0,41,27.83,109.22,88.13,109.22,32.46,0,51-22.75,51-54.61,0-25-25.5-43.23-32.46-47.78-18.55-18.2-25.51-29.58-25.51-54.6,0-45.52,62.6-81.92,90.44-88.75C185.8,88,189.28,84.6,187,72.09,185.8,63,181.16,63,173,63,147.53,63,3.76,103.94,3.76,226.8",
    transform: "translate(-3.76 -62.98)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuotationMarks);
export default __webpack_public_path__ + "static/media/QuotationMarks.a45fbf4ce3c789c948a1df6265948184.svg";
export { ForwardRef as ReactComponent };